export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const LOGOUT = "LOGOUT";
export const CREATE_VERIFY_DATA_SUCCESS = "RETRIEVE_ROLE_SUCCESS";

export const RETRIEVE_ROLE_SUCCESS = "RETRIEVE_ROLE_SUCCESS";
export const RETRIEVE_ROLE_FAIL = "RETRIEVE_ROLE_FAIL";

export const RETRIEVE_CAKUPAN_WILAYAH_SUCCESS =
  "RETRIEVE_CAKUPAN_WILAYAH_SUCCESS";
export const RETRIEVE_CAKUPAN_WILAYAH_FAIL = "RETRIEVE_CAKUPAN_WILAYAH_FAIL";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";
export const RETRIEVE_USER_SUCCESS = "RETRIEVE_USER_SUCCESS";
export const RETRIEVE_USER_FAIL = "RETRIEVE_USER_FAIL";
export const RESET_USER_SUCCESS = "RESET_USER_SUCCESS";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";

export const CREATE_KATEGORI_TEMATIK_SUCCESS =
  "CREATE_KATEGORI_TEMATIK_SUCCESS";
export const CREATE_KATEGORI_TEMATIK_FAIL = "CREATE_KATEGORI_TEMATIK_FAIL";
export const RETRIEVE_KATEGORI_TEMATIK_SUCCESS =
  "RETRIEVE_KATEGORI_TEMATIK_SUCCESS";
export const RETRIEVE_KATEGORI_TEMATIK_FAIL = "RETRIEVE_KATEGORI_TEMATIK_FAIL";
export const UPDATE_KATEGORI_TEMATIK_SUCCESS =
  "UPDATE_KATEGORI_TEMATIK_SUCCESS";
export const UPDATE_KATEGORI_TEMATIK_FAIL = "UPDATE_KATEGORI_TEMATIK_FAIL";
export const DELETE_KATEGORI_TEMATIK_SUCCESS =
  "DELETE_KATEGORI_TEMATIK_SUCCESS";
export const DELETE_KATEGORI_TEMATIK_FAIL = "DELETE_KATEGORI_TEMATIK_FAIL";

export const CREATE_KATEGORI_EKSTERNAL_SUCCESS =
  "CREATE_KATEGORI_EKSTERNAL_SUCCESS";
export const CREATE_KATEGORI_EKSTERNAL_FAIL = "CREATE_KATEGORI_EKSTERNAL_FAIL";
export const RETRIEVE_KATEGORI_EKSTERNAL_SUCCESS =
  "RETRIEVE_KATEGORI_EKSTERNAL_SUCCESS";
export const RETRIEVE_KATEGORI_EKSTERNAL_FAIL =
  "RETRIEVE_KATEGORI_EKSTERNAL_FAIL";
export const UPDATE_KATEGORI_EKSTERNAL_SUCCESS =
  "UPDATE_KATEGORI_EKSTERNAL_SUCCESS";
export const UPDATE_KATEGORI_EKSTERNAL_FAIL = "UPDATE_KATEGORI_EKSTERNAL_FAIL";
export const DELETE_KATEGORI_EKSTERNAL_SUCCESS =
  "DELETE_KATEGORI_EKSTERNAL_SUCCESS";
export const DELETE_KATEGORI_EKSTERNAL_FAIL = "DELETE_KATEGORI_EKSTERNAL_FAIL";

export const CREATE_MEKANISME_EKSTERNAL_SUCCESS =
  "CREATE_MEKANISME_EKSTERNAL_SUCCESS";
export const CREATE_MEKANISME_EKSTERNAL_FAIL =
  "CREATE_MEKANISME_EKSTERNAL_FAIL";
export const RETRIEVE_MEKANISME_EKSTERNAL_SUCCESS =
  "RETRIEVE_MEKANISME_EKSTERNAL_SUCCESS";
export const RETRIEVE_MEKANISME_EKSTERNAL_FAIL =
  "RETRIEVE_MEKANISME_EKSTERNAL_FAIL";
export const UPDATE_MEKANISME_EKSTERNAL_SUCCESS =
  "UPDATE_MEKANISME_EKSTERNAL_SUCCESS";
export const UPDATE_MEKANISME_EKSTERNAL_FAIL =
  "UPDATE_MEKANISME_EKSTERNAL_FAIL";
export const DELETE_MEKANISME_EKSTERNAL_SUCCESS =
  "DELETE_MEKANISME_EKSTERNAL_SUCCESS";
export const DELETE_MEKANISME_EKSTERNAL_FAIL =
  "DELETE_MEKANISME_EKSTERNAL_FAIL";

export const CREATE_PROVINSI_SUCCESS = "CREATE_PROVINSI_SUCCESS";
export const CREATE_PROVINSI_FAIL = "CREATE_PROVINSI_FAIL";
export const RETRIEVE_PROVINSI_SUCCESS = "RETRIEVE_PROVINSI_SUCCESS";
export const RETRIEVE_PROVINSI_FAIL = "RETRIEVE_PROVINSI_FAIL";
export const UPDATE_PROVINSI_SUCCESS = "UPDATE_PROVINSI_SUCCESS";
export const UPDATE_PROVINSI_FAIL = "UPDATE_PROVINSI_FAIL";
export const DELETE_PROVINSI_SUCCESS = "DELETE_PROVINSI_SUCCESS";
export const DELETE_PROVINSI_FAIL = "DELETE_PROVINSI_FAIL";

export const CREATE_BPKHTL_SUCCESS = "CREATE_BPKHTL_SUCCESS";
export const CREATE_BPKHTL_FAIL = "CREATE_BPKHTL_FAIL";
export const RETRIEVE_BPKHTL_SUCCESS = "RETRIEVE_BPKHTL_SUCCESS";
export const RETRIEVE_BPKHTL_FAIL = "RETRIEVE_BPKHTL_FAIL";
export const UPDATE_BPKHTL_SUCCESS = "UPDATE_BPKHTL_SUCCESS";
export const UPDATE_BPKHTL_FAIL = "UPDATE_BPKHTL_FAIL";
export const DELETE_BPKHTL_SUCCESS = "DELETE_BPKHTL_SUCCESS";
export const DELETE_BPKHTL_FAIL = "DELETE_BPKHTL_FAIL";

export const CREATE_EKSTERNAL_SUCCESS = "CREATE_EKSTERNAL_SUCCESS";
export const CREATE_EKSTERNAL_FAIL = "CREATE_EKSTERNAL_FAIL";
export const RETRIEVE_EKSTERNAL_SUCCESS = "RETRIEVE_EKSTERNAL_SUCCESS";
export const RETRIEVE_EKSTERNAL_FAIL = "RETRIEVE_EKSTERNAL_FAIL";
export const UPDATE_EKSTERNAL_SUCCESS = "UPDATE_EKSTERNAL_SUCCESS";
export const UPDATE_EKSTERNAL_FAIL = "UPDATE_EKSTERNAL_FAIL";
export const DELETE_EKSTERNAL_SUCCESS = "DELETE_EKSTERNAL_SUCCESS";
export const DELETE_EKSTERNAL_FAIL = "DELETE_EKSTERNAL_FAIL";

export const CREATE_INTERNAL_SUCCESS = "CREATE_INTERNAL_SUCCESS";
export const CREATE_INTERNAL_FAIL = "CREATE_INTERNAL_FAIL";
export const RETRIEVE_INTERNAL_SUCCESS = "RETRIEVE_INTERNAL_SUCCESS";
export const RETRIEVE_INTERNAL_FAIL = "RETRIEVE_INTERNAL_FAIL";
export const UPDATE_INTERNAL_SUCCESS = "UPDATE_INTERNAL_SUCCESS";
export const UPDATE_INTERNAL_FAIL = "UPDATE_INTERNAL_FAIL";
export const DELETE_INTERNAL_SUCCESS = "DELETE_INTERNAL_SUCCESS";
export const DELETE_INTERNAL_FAIL = "DELETE_INTERNAL_FAIL";

export const CREATE_PRODUSEN_SUCCESS = "CREATE_PRODUSEN_SUCCESS";
export const CREATE_PRODUSEN_FAIL = "CREATE_PRODUSEN_FAIL";
export const RETRIEVE_PRODUSEN_SUCCESS = "RETRIEVE_PRODUSEN_SUCCESS";
export const RETRIEVE_PRODUSEN_FAIL = "RETRIEVE_PRODUSEN_FAIL";
export const UPDATE_PRODUSEN_SUCCESS = "UPDATE_PRODUSEN_SUCCESS";
export const UPDATE_PRODUSEN_FAIL = "UPDATE_PRODUSEN_FAIL";
export const DELETE_PRODUSEN_SUCCESS = "DELETE_PRODUSEN_SUCCESS";
export const DELETE_PRODUSEN_FAIL = "DELETE_PRODUSEN_FAIL";

export const CREATE_REGION_SUCCESS = "CREATE_REGION_SUCCESS";
export const CREATE_REGION_FAIL = "CREATE_REGION_FAIL";
export const RETRIEVE_REGION_SUCCESS = "RETRIEVE_REGION_SUCCESS";
export const RETRIEVE_REGION_FAIL = "RETRIEVE_REGION_FAIL";
export const UPDATE_REGION_SUCCESS = "UPDATE_REGION_SUCCESS";
export const UPDATE_REGION_FAIL = "UPDATE_REGION_FAIL";
export const DELETE_REGION_SUCCESS = "DELETE_REGION_SUCCESS";
export const DELETE_REGION_FAIL = "DELETE_REGION_FAIL";

export const CREATE_BPKHTL_PROVINCE_SUCCESS = "CREATE_BPKHTL_PROVINCE_SUCCESS";
export const CREATE_BPKHTL_PROVINCE_FAIL = "CREATE_BPKHTL_PROVINCE_FAIL";
export const RETRIEVE_BPKHTL_PROVINCE_SUCCESS =
  "RETRIEVE_BPKHTL_PROVINCE_SUCCESS";
export const RETRIEVE_BPKHTL_PROVINCE_FAIL = "RETRIEVE_BPKHTL_PROVINCE_FAIL";
export const UPDATE_BPKHTL_PROVINCE_SUCCESS = "UPDATE_BPKHTL_PROVINCE_SUCCESS";
export const UPDATE_BPKHTL_PROVINCE_FAIL = "UPDATE_BPKHTL_PROVINCE_FAIL";
export const DELETE_BPKHTL_PROVINCE_SUCCESS = "DELETE_BPKHTL_PROVINCE_SUCCESS";
export const DELETE_BPKHTL_PROVINCE_FAIL = "DELETE_BPKHTL_PROVINCE_FAIL";

export const CREATE_BPKHTL_USER_SUCCESS = "CREATE_BPKHTL_USER_SUCCESS";
export const CREATE_BPKHTL_USER_FAIL = "CREATE_BPKHTL_USER_FAIL";
export const RETRIEVE_BPKHTL_USER_SUCCESS = "RETRIEVE_BPKHTL_USER_SUCCESS";
export const RETRIEVE_BPKHTL_USER_FAIL = "RETRIEVE_BPKHTL_USER_FAIL";
export const UPDATE_BPKHTL_USER_SUCCESS = "UPDATE_BPKHTL_USER_SUCCESS";
export const UPDATE_BPKHTL_USER_FAIL = "UPDATE_BPKHTL_USER_FAIL";
export const DELETE_BPKHTL_USER_SUCCESS = "DELETE_BPKHTL_USER_SUCCESS";
export const DELETE_BPKHTL_USER_FAIL = "DELETE_BPKHTL_USER_FAIL";

export const CREATE_EKSTERNAL_USER_SUCCESS = "CREATE_EKSTERNAL_USER_SUCCESS";
export const CREATE_EKSTERNAL_USER_FAIL = "CREATE_EKSTERNAL_USER_FAIL";
export const RETRIEVE_EKSTERNAL_USER_SUCCESS =
  "RETRIEVE_EKSTERNAL_USER_SUCCESS";
export const RETRIEVE_EKSTERNAL_USER_FAIL = "RETRIEVE_EKSTERNAL_USER_FAIL";
export const UPDATE_EKSTERNAL_USER_SUCCESS = "UPDATE_EKSTERNAL_USER_SUCCESS";
export const UPDATE_EKSTERNAL_USER_FAIL = "UPDATE_EKSTERNAL_USER_FAIL";
export const DELETE_EKSTERNAL_USER_SUCCESS = "DELETE_EKSTERNAL_USER_SUCCESS";
export const DELETE_EKSTERNAL_USER_FAIL = "DELETE_EKSTERNAL_USER_FAIL";

export const CREATE_INTERNAL_USER_SUCCESS = "CREATE_INTERNAL_USER_SUCCESS";
export const CREATE_INTERNAL_USER_FAIL = "CREATE_INTERNAL_USER_FAIL";
export const RETRIEVE_INTERNAL_USER_SUCCESS = "RETRIEVE_INTERNAL_USER_SUCCESS";
export const RETRIEVE_INTERNAL_USER_FAIL = "RETRIEVE_INTERNAL_USER_FAIL";
export const UPDATE_INTERNAL_USER_SUCCESS = "UPDATE_INTERNAL_USER_SUCCESS";
export const UPDATE_INTERNAL_USER_FAIL = "UPDATE_INTERNAL_USER_FAIL";
export const DELETE_INTERNAL_USER_SUCCESS = "DELETE_INTERNAL_USER_SUCCESS";
export const DELETE_INTERNAL_USER_FAIL = "DELETE_INTERNAL_USER_FAIL";

export const CREATE_PRODUSEN_USER_SUCCESS = "CREATE_PRODUSEN_USER_SUCCESS";
export const CREATE_PRODUSEN_USER_FAIL = "CREATE_PRODUSEN_USER_FAIL";
export const RETRIEVE_PRODUSEN_USER_SUCCESS = "RETRIEVE_PRODUSEN_USER_SUCCESS";
export const RETRIEVE_PRODUSEN_USER_FAIL = "RETRIEVE_PRODUSEN_USER_FAIL";
export const UPDATE_PRODUSEN_USER_SUCCESS = "UPDATE_PRODUSEN_USER_SUCCESS";
export const UPDATE_PRODUSEN_USER_FAIL = "UPDATE_PRODUSEN_USER_FAIL";
export const DELETE_PRODUSEN_USER_SUCCESS = "DELETE_PRODUSEN_USER_SUCCESS";
export const DELETE_PRODUSEN_USER_FAIL = "DELETE_PRODUSEN_USER_FAIL";

export const CREATE_TEMATIK_SUCCESS = "CREATE_TEMATIK_SUCCESS";
export const CREATE_TEMATIK_FAIL = "CREATE_TEMATIK_FAIL";
export const RETRIEVE_TEMATIK_SUCCESS = "RETRIEVE_TEMATIK_SUCCESS";
export const RETRIEVE_TEMATIK_FAIL = "RETRIEVE_TEMATIK_FAIL";
export const UPDATE_TEMATIK_SUCCESS = "UPDATE_TEMATIK_SUCCESS";
export const UPDATE_TEMATIK_FAIL = "UPDATE_TEMATIK_FAIL";
export const DELETE_TEMATIK_SUCCESS = "DELETE_TEMATIK_SUCCESS";
export const DELETE_TEMATIK_FAIL = "DELETE_TEMATIK_FAIL";

export const CREATE_DATA_PRODUSEN_SUCCESS = "CREATE_DATA_PRODUSEN_SUCCESS";
export const CREATE_DATA_PRODUSEN_FAIL = "CREATE_DATA_PRODUSEN_FAIL";
export const RETRIEVE_DATA_PRODUSEN_SUCCESS = "RETRIEVE_DATA_PRODUSEN_SUCCESS";
export const RETRIEVE_DATA_PRODUSEN_FAIL = "RETRIEVE_DATA_PRODUSEN_FAIL";
export const UPDATE_DATA_PRODUSEN_SUCCESS = "UPDATE_DATA_PRODUSEN_SUCCESS";
export const UPDATE_DATA_PRODUSEN_FAIL = "UPDATE_DATA_PRODUSEN_FAIL";
export const DELETE_DATA_PRODUSEN_SUCCESS = "DELETE_DATA_PRODUSEN_SUCCESS";
export const DELETE_DATA_PRODUSEN_FAIL = "DELETE_DATA_PRODUSEN_FAIL";

export const CREATE_DATA_PERBAIKAN_PRODUSEN_SUCCESS =
  "CREATE_DATA_PERBAIKAN_PRODUSEN_SUCCESS";
export const CREATE_DATA_PERBAIKAN_PRODUSEN_FAIL =
  "CREATE_DATA_PERBAIKAN_PRODUSEN_FAIL";
export const RETRIEVE_DATA_PERBAIKAN_PRODUSEN_SUCCESS =
  "RETRIEVE_DATA_PERBAIKAN_PRODUSEN_SUCCESS";
export const RETRIEVE_DATA_PERBAIKAN_PRODUSEN_FAIL =
  "RETRIEVE_DATA_PERBAIKAN_PRODUSEN_FAIL";
export const UPDATE_DATA_PERBAIKAN_PRODUSEN_SUCCESS =
  "UPDATE_DATA_PERBAIKAN_PRODUSEN_SUCCESS";
export const UPDATE_DATA_PERBAIKAN_PRODUSEN_FAIL =
  "UPDATE_DATA_PERBAIKAN_PRODUSEN_FAIL";
export const DELETE_DATA_PERBAIKAN_PRODUSEN_SUCCESS =
  "DELETE_DATA_PERBAIKAN_PRODUSEN_SUCCESS";
export const DELETE_DATA_PERBAIKAN_PRODUSEN_FAIL =
  "DELETE_DATA_PERBAIKAN_PRODUSEN_FAIL";

export const CREATE_STATUS_PEMERIKSAAN_SUCCESS =
  "CREATE_STATUS_PEMERIKSAAN_SUCCESS";
export const CREATE_STATUS_PEMERIKSAAN_FAIL = "CREATE_STATUS_PEMERIKSAAN_FAIL";
export const RETRIEVE_STATUS_PEMERIKSAAN_SUCCESS =
  "RETRIEVE_STATUS_PEMERIKSAAN_SUCCESS";
export const RETRIEVE_STATUS_PEMERIKSAAN_FAIL =
  "RETRIEVE_STATUS_PEMERIKSAAN_FAIL";
export const UPDATE_STATUS_PEMERIKSAAN_SUCCESS =
  "UPDATE_STATUS_PEMERIKSAAN_SUCCESS";
export const UPDATE_STATUS_PEMERIKSAAN_FAIL = "UPDATE_STATUS_PEMERIKSAAN_FAIL";
export const DELETE_STATUS_PEMERIKSAAN_SUCCESS =
  "DELETE_STATUS_PEMERIKSAAN_SUCCESS";
export const DELETE_STATUS_PEMERIKSAAN_FAIL = "DELETE_STATUS_PEMERIKSAAN_FAIL";

export const CREATE_DATA_PEMERIKSAAN_SUCCESS =
  "CREATE_DATA_PEMERIKSAAN_SUCCESS";
export const CREATE_DATA_PEMERIKSAAN_FAIL = "CREATE_DATA_PEMERIKSAAN_FAIL";
export const RETRIEVE_DATA_PEMERIKSAAN_SUCCESS =
  "RETRIEVE_DATA_PEMERIKSAAN_SUCCESS";
export const RETRIEVE_DATA_PEMERIKSAAN_FAIL = "RETRIEVE_DATA_PEMERIKSAAN_FAIL";
export const UPDATE_DATA_PEMERIKSAAN_SUCCESS =
  "UPDATE_DATA_PEMERIKSAAN_SUCCESS";
export const UPDATE_DATA_PEMERIKSAAN_FAIL = "UPDATE_DATA_PEMERIKSAAN_FAIL";
export const DELETE_DATA_PEMERIKSAAN_SUCCESS =
  "DELETE_DATA_PEMERIKSAAN_SUCCESS";
export const DELETE_DATA_PEMERIKSAAN_FAIL = "DELETE_DATA_PEMERIKSAAN_FAIL";

export const CREATE_IGT_EKSTERNAL_SUCCESS = "CREATE_IGT_EKSTERNAL_SUCCESS";
export const CREATE_IGT_EKSTERNAL_FAIL = "CREATE_IGT_EKSTERNAL_FAIL";
export const RETRIEVE_IGT_EKSTERNAL_SUCCESS = "RETRIEVE_IGT_EKSTERNAL_SUCCESS";
export const RETRIEVE_IGT_EKSTERNAL_FAIL = "RETRIEVE_IGT_EKSTERNAL_FAIL";
export const UPDATE_IGT_EKSTERNAL_SUCCESS = "UPDATE_IGT_EKSTERNAL_SUCCESS";
export const UPDATE_IGT_EKSTERNAL_FAIL = "UPDATE_IGT_EKSTERNAL_FAIL";
export const DELETE_IGT_EKSTERNAL_SUCCESS = "DELETE_IGT_EKSTERNAL_SUCCESS";
export const DELETE_IGT_EKSTERNAL_FAIL = "DELETE_IGT_EKSTERNAL_FAIL";

export const CREATE_IGT_INTERNAL_SUCCESS = "CREATE_IGT_INTERNAL_SUCCESS";
export const CREATE_IGT_INTERNAL_FAIL = "CREATE_IGT_INTERNAL_FAIL";
export const RETRIEVE_IGT_INTERNAL_SUCCESS = "RETRIEVE_IGT_INTERNAL_SUCCESS";
export const RETRIEVE_IGT_INTERNAL_FAIL = "RETRIEVE_IGT_INTERNAL_FAIL";
export const UPDATE_IGT_INTERNAL_SUCCESS = "UPDATE_IGT_INTERNAL_SUCCESS";
export const UPDATE_IGT_INTERNAL_FAIL = "UPDATE_IGT_INTERNAL_FAIL";
export const DELETE_IGT_INTERNAL_SUCCESS = "DELETE_IGT_INTERNAL_SUCCESS";
export const DELETE_IGT_INTERNAL_FAIL = "DELETE_IGT_INTERNAL_FAIL";

export const CREATE_EKSTERNAL_TEMATIK_SUCCESS =
  "CREATE_EKSTERNAL_TEMATIK_SUCCESS";
export const CREATE_EKSTERNAL_TEMATIK_FAIL = "CREATE_EKSTERNAL_TEMATIK_FAIL";
export const RETRIEVE_EKSTERNAL_TEMATIK_SUCCESS =
  "RETRIEVE_EKSTERNAL_TEMATIK_SUCCESS";
export const RETRIEVE_EKSTERNAL_TEMATIK_FAIL =
  "RETRIEVE_EKSTERNAL_TEMATIK_FAIL";
export const UPDATE_EKSTERNAL_TEMATIK_SUCCESS =
  "UPDATE_EKSTERNAL_TEMATIK_SUCCESS";
export const UPDATE_EKSTERNAL_TEMATIK_FAIL = "UPDATE_EKSTERNAL_TEMATIK_FAIL";
export const DELETE_EKSTERNAL_TEMATIK_SUCCESS =
  "DELETE_EKSTERNAL_TEMATIK_SUCCESS";
export const DELETE_EKSTERNAL_TEMATIK_FAIL = "DELETE_EKSTERNAL_TEMATIK_FAIL";

export const CREATE_INTERNAL_TEMATIK_SUCCESS =
  "CREATE_INTERNAL_TEMATIK_SUCCESS";
export const CREATE_INTERNAL_TEMATIK_FAIL = "CREATE_INTERNAL_TEMATIK_FAIL";
export const RETRIEVE_INTERNAL_TEMATIK_SUCCESS =
  "RETRIEVE_INTERNAL_TEMATIK_SUCCESS";
export const RETRIEVE_INTERNAL_TEMATIK_FAIL = "RETRIEVE_INTERNAL_TEMATIK_FAIL";
export const UPDATE_INTERNAL_TEMATIK_SUCCESS =
  "UPDATE_INTERNAL_TEMATIK_SUCCESS";
export const UPDATE_INTERNAL_TEMATIK_FAIL = "UPDATE_INTERNAL_TEMATIK_FAIL";
export const DELETE_INTERNAL_TEMATIK_SUCCESS =
  "DELETE_INTERNAL_TEMATIK_SUCCESS";
export const DELETE_INTERNAL_TEMATIK_FAIL = "DELETE_INTERNAL_TEMATIK_FAIL";

export const CREATE_EKSTERNAL_PROVINCE_SUCCESS =
  "CREATE_EKSTERNAL_PROVINCE_SUCCESS";
export const CREATE_EKSTERNAL_PROVINCE_FAIL = "CREATE_EKSTERNAL_PROVINCE_FAIL";
export const RETRIEVE_EKSTERNAL_PROVINCE_SUCCESS =
  "RETRIEVE_EKSTERNAL_PROVINCE_SUCCESS";
export const RETRIEVE_EKSTERNAL_PROVINCE_FAIL =
  "RETRIEVE_EKSTERNAL_PROVINCE_FAIL";
export const UPDATE_EKSTERNAL_PROVINCE_SUCCESS =
  "UPDATE_EKSTERNAL_PROVINCE_SUCCESS";
export const UPDATE_EKSTERNAL_PROVINCE_FAIL = "UPDATE_EKSTERNAL_PROVINCE_FAIL";
export const DELETE_EKSTERNAL_PROVINCE_SUCCESS =
  "DELETE_EKSTERNAL_PROVINCE_SUCCESS";
export const DELETE_EKSTERNAL_PROVINCE_FAIL = "DELETE_EKSTERNAL_PROVINCE_FAIL";

export const CREATE_INTERNAL_PROVINCE_SUCCESS =
  "CREATE_INTERNAL_PROVINCE_SUCCESS";
export const CREATE_INTERNAL_PROVINCE_FAIL = "CREATE_INTERNAL_PROVINCE_FAIL";
export const RETRIEVE_INTERNAL_PROVINCE_SUCCESS =
  "RETRIEVE_INTERNAL_PROVINCE_SUCCESS";
export const RETRIEVE_INTERNAL_PROVINCE_FAIL =
  "RETRIEVE_INTERNAL_PROVINCE_FAIL";
export const UPDATE_INTERNAL_PROVINCE_SUCCESS =
  "UPDATE_INTERNAL_PROVINCE_SUCCESS";
export const UPDATE_INTERNAL_PROVINCE_FAIL = "UPDATE_INTERNAL_PROVINCE_FAIL";
export const DELETE_INTERNAL_PROVINCE_SUCCESS =
  "DELETE_INTERNAL_PROVINCE_SUCCESS";
export const DELETE_INTERNAL_PROVINCE_FAIL = "DELETE_INTERNAL_PROVINCE_FAIL";

export const CREATE_EKSTERNAL_REGION_SUCCESS =
  "CREATE_EKSTERNAL_REGION_SUCCESS";
export const CREATE_EKSTERNAL_REGION_FAIL = "CREATE_EKSTERNAL_REGION_FAIL";
export const RETRIEVE_EKSTERNAL_REGION_SUCCESS =
  "RETRIEVE_EKSTERNAL_REGION_SUCCESS";
export const RETRIEVE_EKSTERNAL_REGION_FAIL = "RETRIEVE_EKSTERNAL_REGION_FAIL";
export const UPDATE_EKSTERNAL_REGION_SUCCESS =
  "UPDATE_EKSTERNAL_REGION_SUCCESS";
export const UPDATE_EKSTERNAL_REGION_FAIL = "UPDATE_EKSTERNAL_REGION_FAIL";
export const DELETE_EKSTERNAL_REGION_SUCCESS =
  "DELETE_EKSTERNAL_REGION_SUCCESS";
export const DELETE_EKSTERNAL_REGION_FAIL = "DELETE_EKSTERNAL_REGION_FAIL";

export const CREATE_INTERNAL_REGION_SUCCESS = "CREATE_INTERNAL_REGION_SUCCESS";
export const CREATE_INTERNAL_REGION_FAIL = "CREATE_INTERNAL_REGION_FAIL";
export const RETRIEVE_INTERNAL_REGION_SUCCESS =
  "RETRIEVE_INTERNAL_REGION_SUCCESS";
export const RETRIEVE_INTERNAL_REGION_FAIL = "RETRIEVE_INTERNAL_REGION_FAIL";
export const UPDATE_INTERNAL_REGION_SUCCESS = "UPDATE_INTERNAL_REGION_SUCCESS";
export const UPDATE_INTERNAL_REGION_FAIL = "UPDATE_INTERNAL_REGION_FAIL";
export const DELETE_INTERNAL_REGION_SUCCESS = "DELETE_INTERNAL_REGION_SUCCESS";
export const DELETE_INTERNAL_REGION_FAIL = "DELETE_INTERNAL_REGION_FAIL";

export const CREATE_DATA_BPKHTL_SUCCESS = "CREATE_DATA_BPKHTL_SUCCESS";
export const CREATE_DATA_BPKHTL_FAIL = "CREATE_DATA_BPKHTL_FAIL";
export const RETRIEVE_DATA_BPKHTL_SUCCESS = "RETRIEVE_DATA_BPKHTL_SUCCESS";
export const RETRIEVE_DATA_BPKHTL_FAIL = "RETRIEVE_DATA_BPKHTL_FAIL";
export const UPDATE_DATA_BPKHTL_SUCCESS = "UPDATE_DATA_BPKHTL_SUCCESS";
export const UPDATE_DATA_BPKHTL_FAIL = "UPDATE_DATA_BPKHTL_FAIL";
export const DELETE_DATA_BPKHTL_SUCCESS = "DELETE_DATA_BPKHTL_SUCCESS";
export const DELETE_DATA_BPKHTL_FAIL = "DELETE_DATA_BPKHTL_FAIL";

export const CREATE_DATA_EKSTERNAL_SUCCESS = "CREATE_DATA_EKSTERNAL_SUCCESS";
export const CREATE_DATA_EKSTERNAL_FAIL = "CREATE_DATA_EKSTERNAL_FAIL";
export const RETRIEVE_DATA_EKSTERNAL_SUCCESS =
  "RETRIEVE_DATA_EKSTERNAL_SUCCESS";
export const RETRIEVE_DATA_EKSTERNAL_FAIL = "RETRIEVE_DATA_EKSTERNAL_FAIL";
export const UPDATE_DATA_EKSTERNAL_SUCCESS = "UPDATE_DATA_EKSTERNAL_SUCCESS";
export const UPDATE_DATA_EKSTERNAL_FAIL = "UPDATE_DATA_EKSTERNAL_FAIL";
export const DELETE_DATA_EKSTERNAL_SUCCESS = "DELETE_DATA_EKSTERNAL_SUCCESS";
export const DELETE_DATA_EKSTERNAL_FAIL = "DELETE_DATA_EKSTERNAL_FAIL";

export const CREATE_DATA_INTERNAL_SUCCESS = "CREATE_DATA_INTERNAL_SUCCESS";
export const CREATE_DATA_INTERNAL_FAIL = "CREATE_DATA_INTERNAL_FAIL";
export const RETRIEVE_DATA_INTERNAL_SUCCESS = "RETRIEVE_DATA_INTERNAL_SUCCESS";
export const RETRIEVE_DATA_INTERNAL_FAIL = "RETRIEVE_DATA_INTERNAL_FAIL";
export const UPDATE_DATA_INTERNAL_SUCCESS = "UPDATE_DATA_INTERNAL_SUCCESS";
export const UPDATE_DATA_INTERNAL_FAIL = "UPDATE_DATA_INTERNAL_FAIL";
export const DELETE_DATA_INTERNAL_SUCCESS = "DELETE_DATA_INTERNAL_SUCCESS";
export const DELETE_DATA_INTERNAL_FAIL = "DELETE_DATA_INTERNAL_FAIL";

export const CREATE_DATA_PUBLIKASI_SUCCESS = "CREATE_DATA_PUBLIKASI_SUCCESS";
export const CREATE_DATA_PUBLIKASI_FAIL = "CREATE_DATA_PUBLIKASI_FAIL";
export const RETRIEVE_DATA_PUBLIKASI_SUCCESS =
  "RETRIEVE_DATA_PUBLIKASI_SUCCESS";
export const RETRIEVE_DATA_PUBLIKASI_FAIL = "RETRIEVE_DATA_PUBLIKASI_FAIL";
export const UPDATE_DATA_PUBLIKASI_SUCCESS = "UPDATE_DATA_PUBLIKASI_SUCCESS";
export const UPDATE_DATA_PUBLIKASI_FAIL = "UPDATE_DATA_PUBLIKASI_FAIL";
export const DELETE_DATA_PUBLIKASI_SUCCESS = "DELETE_DATA_PUBLIKASI_SUCCESS";
export const DELETE_DATA_PUBLIKASI_FAIL = "DELETE_DATA_PUBLIKASI_FAIL";

export const CREATE_KATEGORI_INTERNAL_SUCCESS =
  "CREATE_KATEGORI_INTERNAL_SUCCESS";
export const CREATE_KATEGORI_INTERNAL_FAIL = "CREATE_KATEGORI_INTERNAL_FAIL";
export const RETRIEVE_KATEGORI_INTERNAL_SUCCESS =
  "RETRIEVE_KATEGORI_INTERNAL_SUCCESS";
export const RETRIEVE_KATEGORI_INTERNAL_FAIL =
  "RETRIEVE_KATEGORI_INTERNAL_FAIL";
export const UPDATE_KATEGORI_INTERNAL_SUCCESS =
  "UPDATE_KATEGORI_INTERNAL_SUCCESS";
export const UPDATE_KATEGORI_INTERNAL_FAIL = "UPDATE_KATEGORI_INTERNAL_FAIL";
export const DELETE_KATEGORI_INTERNAL_SUCCESS =
  "DELETE_KATEGORI_INTERNAL_SUCCESS";
export const DELETE_KATEGORI_INTERNAL_FAIL = "DELETE_KATEGORI_INTERNAL_FAIL";

export const CREATE_AKTIFITAS_SUCCESS = "CREATE_AKTIFITAS_SUCCESS";
export const CREATE_AKTIFITAS_FAIL = "CREATE_AKTIFITAS_FAIL";
export const RETRIEVE_AKTIFITAS_SUCCESS = "RETRIEVE_AKTIFITAS_SUCCESS";
export const RETRIEVE_AKTIFITAS_FAIL = "RETRIEVE_AKTIFITAS_FAIL";
export const RESET_AKTIFITAS_SUCCESS = "RESET_AKTIFITAS_SUCCESS";
export const UPDATE_AKTIFITAS_SUCCESS = "UPDATE_AKTIFITAS_SUCCESS";
export const UPDATE_AKTIFITAS_FAIL = "UPDATE_AKTIFITAS_FAIL";
export const DELETE_AKTIFITAS_SUCCESS = "DELETE_AKTIFITAS_SUCCESS";
export const DELETE_AKTIFITAS_FAIL = "DELETE_AKTIFITAS_FAIL";

export const CREATE_NOTIFIKASI_SUCCESS = "CREATE_NOTIFIKASI_SUCCESS";
export const CREATE_NOTIFIKASI_FAIL = "CREATE_NOTIFIKASI_FAIL";
export const RETRIEVE_NOTIFIKASI_SUCCESS = "RETRIEVE_NOTIFIKASI_SUCCESS";
export const RETRIEVE_NOTIFIKASI_FAIL = "RETRIEVE_NOTIFIKASI_FAIL";
export const RESET_NOTIFIKASI_SUCCESS = "RESET_NOTIFIKASI_SUCCESS";
export const UPDATE_NOTIFIKASI_SUCCESS = "UPDATE_NOTIFIKASI_SUCCESS";
export const UPDATE_NOTIFIKASI_FAIL = "UPDATE_NOTIFIKASI_FAIL";
export const DELETE_NOTIFIKASI_SUCCESS = "DELETE_NOTIFIKASI_SUCCESS";
export const DELETE_NOTIFIKASI_FAIL = "DELETE_NOTIFIKASI_FAIL";

export const CREATE_SETTING_SUCCESS = "CREATE_SETTING_SUCCESS";
export const CREATE_SETTING_FAIL = "CREATE_SETTING_FAIL";
export const RETRIEVE_SETTING_SUCCESS = "RETRIEVE_SETTING_SUCCESS";
export const RETRIEVE_SETTING_FAIL = "RETRIEVE_SETTING_FAIL";
export const RESET_SETTING_SUCCESS = "RESET_SETTING_SUCCESS";
export const UPDATE_SETTING_SUCCESS = "UPDATE_SETTING_SUCCESS";
export const UPDATE_SETTING_FAIL = "UPDATE_SETTING_FAIL";
export const DELETE_SETTING_SUCCESS = "DELETE_SETTING_SUCCESS";
export const DELETE_SETTING_FAIL = "DELETE_SETTING_FAIL";
